import $ from 'jquery';

export class AutoPageBreaker {

  // Close to paper size
  PAGE_SIZE = 1200;

  // Margins reduce the space of the usable content
  CONTENT_FIT_OFFSET = 0;

  maxRetries = 10;
  retryDelayMs = 100;

  getMeasuredHeight ($element) {
    if (!$element || $element.length === 0) {
      return 0;
    }

    const domElement = $element.get(0);
    return Math.ceil(
      $element.height() ||
      $element.outerHeight(true) ||
      (domElement && domElement.getBoundingClientRect
        ? domElement.getBoundingClientRect().height
        : 0) ||
      (domElement && domElement.scrollHeight) ||
      0
    );
  }

  getPdfPage (location) {
    let page = 0;
    while (true) {
      if (location >= (this.PAGE_SIZE * page) && location < (this.PAGE_SIZE * (page + 1))) {
        return page;
      } else {
        ++page;
      }
    }
  };

  applyPageBreak (name, cardId, itemId, startingHeight, callback, retryCount = 0) {
    // Find the first item in the list (which should exist because the list is rendered

    // Find the title
    const card = $(`#${cardId}`);
    const cardHeight = this.getMeasuredHeight(card);

    if (!cardHeight) {
      if (retryCount >= this.maxRetries) {
        if (!!callback) {
          callback();
        }
        return;
      }

      setTimeout(() => {
        this.applyPageBreak(name, cardId, itemId, startingHeight, callback, retryCount + 1);
      }, this.retryDelayMs);
      return;
    }

    // Once we have the card height
    let appliedHeight = false;
    // If we are looking to actually auto apply, we need an item too
    if (!!itemId) {
      const firstItem = $(`#${itemId}`);
      const firstItemHeight = this.getMeasuredHeight(firstItem);
      if (!!firstItemHeight) {
        // Get the page where this item 'starts'
        // Get the page where the 'bottom' of the first child is
        // if they are different pages, we need a page break
        const pageCard = this.getPdfPage(startingHeight.height);
        const pageFirstItem = this.getPdfPage(
          startingHeight.height + firstItemHeight + this.CONTENT_FIT_OFFSET);

        if (pageCard !== pageFirstItem) {
          if (!card.hasClass('page-break-before')) {
            card.addClass('page-break-before');
          }

          appliedHeight = true;
          startingHeight.setHeight(pageFirstItem * this.PAGE_SIZE + cardHeight);
        }
      }
    }

    if (!appliedHeight) {
      if (!!itemId) {
        // If we got here, the item just didn't use any dynamic page breaks
        startingHeight.setHeight(startingHeight.height + cardHeight);
      } else {
        // If the item has auto page break applied to it and it bleeds over to the next page,
        // we need to be aware of it
        const pageTop = this.getPdfPage(startingHeight.height);
        const pageBottom = this.getPdfPage(
          startingHeight.height + cardHeight + this.CONTENT_FIT_OFFSET);
        if (pageTop !== pageBottom) {
          startingHeight.setHeight(pageBottom * this.PAGE_SIZE + cardHeight);
        } else {
          startingHeight.setHeight(startingHeight.height + cardHeight);
        }
      }
    }

    if (!!callback) {
      callback();
    }
  };

  applyPageBreakIfNeeded (name, cardId, itemId, startingHeight, callback) {
    setTimeout(() => {
      this.applyPageBreak(name, cardId, itemId, startingHeight, callback);
    }, 500);
  }

  trackHeight (name, cardId, startingHeight, callback) {
    setTimeout(() => {
      this.applyPageBreak(name, cardId, null, startingHeight, callback);
    }, 500);
  }
}

export class StartingHeight {

  height = 0;

  setHeight (height) {
    this.height = parseInt(height, 10);
  }
}
